module.exports = __webpack_public_path__ + "static/img/case_detail_05_2_h5.97ce2d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_05_2_h5.png
// module id = FC6f
// module chunks = 34